import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/task/task.component';
import { CategoriesService } from 'src/app/service/categories.service';
import { OperatingproceduresService } from 'src/app/service/operatingprocedures.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, debounceTime, startWith, map } from 'rxjs';

@Component({
  selector: 'app-add-task-dialog',
  templateUrl: './add-task-dialog.component.html',
  styleUrls: ['./add-task-dialog.component.scss'],
  standalone: false ,  // NOSONAR
})
export class AddTaskDialogComponent implements OnInit {

  taskID;
  heading;
  categoriesData;
  selectedCategory;
  selectedOP;
  OPData = [];
  action;

  description;
  catID;
  catDesc;
  OPDesc;
  OPID;

  currentOP;
  currentCategory;

  enableError: boolean = false;
  errormsg;
  temp;
  temp2: string;
  OPDropdown: any = [];
  OPDataTemp: any = [];

  catDataTemp: any = [];
  catDropdown: any = [];
  catFilterControl = new FormControl('');
  filteredCategories = new BehaviorSubject<any[]>([]);
  opFilterControl = new FormControl('');
  filteredOPDropdown = new BehaviorSubject<any[]>([]);
  constructor(public dialogRef: MatDialogRef<AddTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: DialogData,
    private readonly categoriesService: CategoriesService,
    private readonly OPService: OperatingproceduresService, private  readonly ngxUiLoaderService: NgxUiLoaderService) {

    //fetch from local-storage
    this.temp2 = localStorage.getItem('OP-data');
    this.OPData = JSON.parse(this.temp2);


    this.OPData?.forEach(element => {
      

      const obj = { "label": element.description, "value": element.opID };
      this.OPDataTemp.push(obj);
    });

    this.OPDropdown = this.OPDataTemp;

    //fetch from local-storage
    this.temp = localStorage.getItem('categories-data');
    this.categoriesData = JSON.parse(this.temp);


    this.categoriesData?.forEach(element => {
     

     const  obj = { "label": element.description, "value": element.categoryID };
      this.catDataTemp.push(obj);
    });

    this.catDropdown = this.catDataTemp;


    if (this.dataStore.performAction == 'EditCell') {  // NOSONAR
      this.heading = "Edit";
      this.taskID = this.dataStore.task_id;
      this.action = 'EditCell';
      this.description = this.dataStore.placeholderdesc;
      this.currentCategory = this.dataStore.placeholdercate;
      this.currentOP = this.dataStore.placeholderOP;

    


      this.ngxUiLoaderService.start("loader-01");
     

      //current OP
      this.OPData?.filter(x => x.opID == this.currentOP).forEach(e => {  // NOSONAR
        this.OPDesc = e.description;
      });

      

      // current category
      this.categoriesData?.filter(x => x.categoryID == this.currentCategory).forEach(e => {  // NOSONAR
        this.catDesc = e.description;
      });

      
      this.selectedCategory = this.catDropdown?.find(x => x.label == this.catDesc)  // NOSONAR
      this.selectedOP = this.OPDropdown?.find(x => x.label == this.OPDesc)  // NOSONAR
      this.ngxUiLoaderService.stop("loader-01");
      console.info(this.OPDropdown, "this.OPDropdown")
      console.info(this.OPDesc, "this.OPDesc")

    }

    else {
      this.heading = "Add";
      this.taskID = "Auto assigned";
      this.action = 'AddCell';



    }

  }

  ngOnInit(): void {
    this.filteredCategories.next(this.catDropdown);  // initial load

    this.catFilterControl.valueChanges.pipe(
      debounceTime(200),
      startWith(''),
      map(search =>
        search ? this.catDropdown.filter(cat =>
          cat.label?.toLowerCase().includes(search.toLowerCase())
        ) : this.catDropdown
      )
    ).subscribe(filtered => {
      this.filteredCategories.next(filtered);
    });
    console.info(this.catDropdown, "this.catDropdown")
    console.info(this.selectedCategory, "this.selectedCategory")


    this.filteredOPDropdown.next(this.OPDropdown);  // Initial list

    this.opFilterControl.valueChanges.pipe(
      debounceTime(200),
      startWith(''),
      map(search =>
        search ? this.OPDropdown.filter(op =>
          op.label?.toLowerCase().includes(search.toLowerCase())
        ) : this.OPDropdown
      )
    ).subscribe(filtered => {
      this.filteredOPDropdown.next(filtered);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }
  public saveClick() {



    if (this.action == 'AddCell') {  // NOSONAR

      this.catID = this.selectedCategory?.value;
      this.OPID = this.selectedOP?.value;

      this.categoriesData?.filter(x => x.categoryID == this.catID).forEach(e => {  // NOSONAR
        this.catDesc = e.description;
      });

      this.OPData?.filter(x => x.opID == this.OPID).forEach(e => {  // NOSONAR
        this.OPDesc = e.description;
      });

      if (!this.description || this.description.trim().length == 0) {  // NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }
      else {
        this.dialogRef.close({
          event: this.action, data1: this.description, data2: this.catID, data3: this.catDesc,
          data4: this.OPDesc, data5: this.OPID
        });
      }
    }

    if (this.action == 'EditCell') {  // NOSONAR

      if (this.selectedCategory) {
        this.catID = this.selectedCategory?.value;
      }
      else {
        this.catID = this.currentCategory;
      }

      if (this.selectedOP) {
        this.OPID = this.selectedOP?.value;
      }
      else {
        this.OPID = this.currentOP;
      }



      this.categoriesData?.filter(x => x.categoryID == this.catID).forEach(e => {  // NOSONAR
        this.catDesc = e.description;
      });

      this.OPData?.filter(x => x.opID == this.OPID).forEach(e => {  // NOSONAR
        this.OPDesc = e.description;
      });


      if (!this.description || this.description.trim().length == 0) {  // NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }
      else {
        this.dialogRef.close({
          event: this.action, data1: this.description, data2: this.catID, data3: this.catDesc,
          data4: this.OPDesc, data5: this.OPID
        });
      }
    }
  }
}
